// Prepare final material variants without compileAsync readiness polling,
// which can throw outside its promise in the CDN runtime and leave startup hung.
export async function prepareSceneShaders(viewer, shouldContinue) {
  // An environment arriving after compilation changes material shader variants.
  // Its download runs alongside model loading; prepare the final variants once.
  await viewer.environmentReady;
  // The user may leave 3D or replace this viewer while HDR is loading.
  // Only prepare the current viewer; the previous renderer may be disposed.
  if (!shouldContinue()) {
    return false;
  }

  if (typeof viewer.renderer.compile === 'function') {
    viewer.renderer.compile(viewer.scene, viewer.camera);
  }

  return shouldContinue();
}
